<div class="badges d-flex flex-wrap justify-content-center justify-content-xl-start" elementDataTest="achievementsContainerElement">
    <div *ngFor="let achievement of achievements" class="badge">
        <app-achievement
            [@ShowHide]="{
                value: true,
                params: {
                    time: '0.5s',
                },
            }"
            [achievement]="achievement"
        ></app-achievement>
    </div>
</div>

<div *ngIf="loading$ | async" [ngClass]="type === 'me' ? '' : 'py-5'">
    <app-loader loaderColor="black"></app-loader>
</div>

<div *ngIf="(loading$ | async) === false && !hasBadges" [style.height.rem]="2.5">
    <div class="text-xs color-muted" translate>v3-achievements-no-badges-info</div>
</div>
